import { PricingYearId } from "app/shared/model";

type ResolveActivePricingYearArgs = {
  pricingYears: PricingYearId[];
  selectedPricingYearId?: number;
  selectedYear?: Pick<PricingYearId, "id" | "year"> | null;
};

export function resolveActivePricingYear({
  pricingYears,
  selectedPricingYearId,
  selectedYear,
}: ResolveActivePricingYearArgs): PricingYearId | undefined {
  if (!pricingYears.length) return undefined;

  const candidateIds = [selectedYear?.id, selectedPricingYearId].filter(
    (id): id is number => id != null && Number.isFinite(id),
  );

  for (const id of candidateIds) {
    const match = pricingYears.find((py) => py.id === id);
    if (match) return match;
  }

  if (selectedYear?.year != null) {
    return pricingYears.find((py) => py.year === selectedYear.year);
  }

  return undefined;
}